import React from 'react';
import InfoDialog from 'swag-client-common/components/info/info-dialog';
import classes from './no-design-popup.scss';
export function NoDesignPopup(props) {
  const {
    onClose,
    uploadWarningPopupContent,
    isLimitedEdition
  } = props;
  return /*#__PURE__*/React.createElement(InfoDialog, {
    dataPopup: "NoDesignWarning",
    header: "You need to upload a design",
    content: /*#__PURE__*/React.createElement("p", null, uploadWarningPopupContent),
    titleContentClass: isLimitedEdition ? classes.orangeSubHeader : '',
    closeButtonClassName: isLimitedEdition ? classes.orangeBackground : '',
    onRequestClose: onClose,
    showCloseButton: true,
    open: true,
    isResponsive: true
  });
}